export { default } from './Col.js'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Layout/Col/index.js